export const getDesignationApproversApi = 'auth/designations';
export const requestAccessApi = 'auth/designations/assign';

export const getEntityDetailsApi = (id: string) =>
  `/approval_service/approval_entity/${id}`;

export const getEntityActionsApi =
  '/approval_service/approval_entity/entity_allowed_actions';

export const performApprovalEntityActionApi =
  '/approval_service/approval_entity/upsert_entity_action';
